import React from "react";
import gql from "graphql-tag";
import { Flex } from "@atoms";
import { useWindowSize } from "@hooks";
import { REACT_SOCKS_BREAKPOINTS } from "@styles";
import { CreateSubGroup } from "../Modals/CreateSubGroup";
import { InviteNewMember } from "../InviteNewMember";
import { HeaderLinksFragment_groups } from "./__generated__/HeaderLinksFragment";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  groups: HeaderLinksFragment_groups[];
}

// == Constants ============================================================

HeaderLinks.fragment = gql`
  fragment HeaderLinksFragment on Campaign {
    id
    groups {
      id
      ...CreateSubGroupFragment
    }
  }
  ${CreateSubGroup.fragment}
`;

// == Component ============================================================

export default function HeaderLinks({ groups }: IProps) {
  const { width } = useWindowSize();
  return (
    <Flex
      flexDirection={width > REACT_SOCKS_BREAKPOINTS[2].medium ? "row" : "column"}
      justifyContent="space-around"
      paddingY={[0, 0, 3]}
      width={1}
    >
      <InviteNewMember />
      <CreateSubGroup groups={groups} />
    </Flex>
  );
}

// == Styles ===============================================================
